export enum ERROR_CODE {
	BAD_FORMAT = 'bad_format',
	MIN_COUNT = 'min_count_:data',
	MAX_COUNT = 'max_count_:data',
	PASSWORD_BAD_FORMAT = 'password_bad_format',
}

export enum VALIDATOR_ERROR_MESSAGE {
	MORE = 'more',
	LESS = 'less',
	MIN = 'min',
	MAX = 'max',
	EQUALS = 'equals',
}
